import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'youtubeSrcset',
  standalone: true,
})
export class YoutubeSrcsetPipe implements PipeTransform {
  transform(url: string | undefined | null): string {
    if (!url) {
      return '';
    }

    const youtubeRegex =
      /https?:\/\/(?:img\.youtube\.com|i\.ytimg\.com)\/vi\/([^/]+)\/.*\.jpg/;
    const match = url.match(youtubeRegex);

    if (match && match[1]) {
      const videoId = match[1];
      const baseUrl = `https://img.youtube.com/vi/${videoId}`;
      return `${baseUrl}/mqdefault.jpg 320w, ${baseUrl}/hqdefault.jpg 480w, ${baseUrl}/maxresdefault.jpg 1280w`;
    }

    return '';
  }
}
